import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UnSyncedEdgesState } from './unsynced-edges.reducer';

export const unSyncedEdgesState = createFeatureSelector<UnSyncedEdgesState>('unSyncedEdgesState');

export const selectUnSyncedEdges = createSelector(
  unSyncedEdgesState, 
  (state: UnSyncedEdgesState) => state.edges
);

export const selectInitialLoading = createSelector(
  unSyncedEdgesState, 
  (state: UnSyncedEdgesState) => state.initialLoading
);

export const selectFilters = createSelector(
  unSyncedEdgesState, 
  (state: UnSyncedEdgesState) => state.filters
);

export const selectError = createSelector(
  unSyncedEdgesState,
  (state: UnSyncedEdgesState) => state.error
);

export const selectUnSyncedEdgesPage = createSelector(unSyncedEdgesState, (state) => state.page);
export const selectHasMoreUnSyncedEdges = createSelector(unSyncedEdgesState, (state) => state.edges.length < state.total); 